import * as React from "react"
import { createPortal } from "react-dom"
import { cn } from "@/lib/utils"
import { lockScroll, unlockScroll } from "@/shared/ui/scrollLock"

export interface ModalProps {
  open: boolean
  onOpenChange: (v:boolean)=>void
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
  dismissible?: boolean // fecha ao clicar fora/Escape (default: true)
}

export function Modal({ open, onOpenChange, className, style, children, dismissible = true }: ModalProps) {
  // Always register hooks in the same order (no conditional hook calls)
  React.useEffect(() => {
    if (!open) return
    const onKey = (e: KeyboardEvent) => { if (dismissible && e.key === 'Escape') onOpenChange(false) }
    document.addEventListener('keydown', onKey)
    return () => { document.removeEventListener('keydown', onKey) }
  }, [open, dismissible])

  React.useEffect(() => {
    if (!open) return
    lockScroll()
    return () => { unlockScroll() }
  }, [open])

  if (!open) return null

  const node = (
    <div className="fixed inset-0 z-[100000] flex items-center justify-center p-4 sm:p-6">
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={() => {
          if (dismissible) onOpenChange(false)
        }}
      />
      <div
        className={cn(
          "relative z-10 w-full max-w-2xl rounded-xl border border-border bg-card p-6 text-card-foreground shadow-xl",
          "max-h-[85vh] overflow-y-auto",
          className,
        )}
        style={style}
      >
        {children}
      </div>
    </div>
  )
  return createPortal(node, document.body)
}
